import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./reducers/layout/authSlice";
import LayoutSlice from "./reducers/layout/layoutSlice";
import ThemeCustomizerSlice from "./reducers/layout/themeCustomizerSlice";
import ProjectSlice from "./reducers/projectSlice";
import FilterSlice from "./reducers/eCommerce/filterSlice";
import AddProductSlice from "./reducers/eCommerce/addProductSlice";
import CartSlice from "./reducers/eCommerce/cartSlice";
import ProductSlice from "./reducers/eCommerce/productSlice";
import ContactSlice from "./reducers/contactSlice";
import TaskSlice from "./reducers/taskSlice";
import ChatSlice from "./reducers/chatSlice";
import BookmarkTabSlice from "./reducers/bookmarkTabsSlice";
import LetterBoxSlice from "./reducers/letterBoxSlice";
import ToDoSlice from "./reducers/toDoSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    layout: LayoutSlice,
    themeCustomizer: ThemeCustomizerSlice,
    project: ProjectSlice,
    filterData: FilterSlice,
    addProduct: AddProductSlice,
    cartData: CartSlice,
    product: ProductSlice,
    contact: ContactSlice,
    task: TaskSlice,
    chat: ChatSlice,
    bookmarkTab: BookmarkTabSlice,
    letterBox: LetterBoxSlice,
    todo: ToDoSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
